<template>
    <div class="back">
        <p>{{$t('zlfk.backInfo')}}</p>
        <div style="width:800px;">
            <el-form size="small" :disabled="true" label-position="left" label-width="160px" :model="backForm">
            <el-form-item :label="$t('zlfk.fyTime')">
              <el-input v-model="backForm.serviceCenterDispatchTime"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zlfk.fyId')">
              <el-input v-model="backForm.shipmentNumber"></el-input>
            </el-form-item>
            <el-form-item :label="$t('zlfk.ckdate')">
              <el-input v-model="backForm.actualWarehouseDepartureTime"></el-input>
            </el-form-item>
        </el-form>
        </div>
        
        <div style="margin-left:110px;">
            <el-button size="small" :disabled="isSubmit" v-show="!backForm.isKonw" type="primary" @click="handleKnow">{{$t('zlfk.know')}}</el-button>

            <el-button size="small" :disabled="isSubmit" @click="back">{{$t('zlfk.backto')}}</el-button>
        </div>
        <el-button style="position: absolute;bottom:60px;right:110px;" size="small" @click="back" plain>{{$t('zlfk.backto')}}</el-button>
    </div>
</template>
<script>
import { knowWaybill } from '@/api/feedback'
import { getSession } from '@/util/localStor'
export default {
    data(){
        return{
            backForm:{},
            isSubmit:false,
        }
    },
    mounted(){
        this.backForm = getSession('feedBackWaybill')
    },
    methods:{
        back(){
            this.$router.go(-1)
        },
        async handleKnow(){
            this.isSubmit = true
            let query = {
                data:{
                    carQualityFeedbackNotifyId:this.backForm.konwId
                }
            }
            const res = await knowWaybill(query)
            if(res.status==0){
                this.isSubmit = false
                this.back()
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.back{
    padding-top: 20px;
    padding-left: 10px;
    p{
        font-size: 18px;
        font-weight: bold;
        line-height: 40px;
    }
    ::v-deep .el-input.is-disabled .el-input__inner{
        width: 300px;
    }
}
</style>